export default {
  USBProducts(state) {
    return state.usbProducts;
  },
  USBLicenseTexts(state) {
    return state.usbLicenseTexts;
  },
  USBDBResponse(state) {
    return state.usbData;
  },
  USBAPIError(state) {
    return state.isUSBAPIError;
  }
};